// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nh3[data-v-8efdb386] {\n  font-weight: 600;\n  font-size: 16px;\n  margin-bottom: 16px;\n}\np[data-v-8efdb386] {\n  font-weight: 500;\n  font-size: 14px;\n  color: #868e96;\n  margin-bottom: 16px;\n}\n.dot[data-v-8efdb386]{\n  width:4px;\n  height:4px;\n  margin-right: 8px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
